import { render, staticRenderFns } from "./BooleanIcon.vue?vue&type=template&id=09709146&lang=pug&"
import script from "./BooleanIcon.vue?vue&type=script&lang=ts&"
export * from "./BooleanIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports